'use client'

import type { VippsRegisterModalProps } from '@maestro/commerce-blocks/components/vipps-register-modal/vipps-register-modal.types'

import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import { useVippsRegisterModal } from '@maestro/commerce-blocks/components/vipps-register-modal/batons/use-vipps-register-modal'
import { SlideInBody } from '@pearlconvert/ui/components/slide-in'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

const VippsRegisterForm = dynamic(() =>
  import('@maestro/commerce-blocks/components/vipps-register-form/vipps-register-form').then(
    (mod) => ({ default: mod.VippsRegisterForm })
  )
)

export default function VippsRegisterModal({
  consents,
  cmsPlaceholders,
}: VippsRegisterModalProps) {
  const t = useTranslations('commerce-blocks')
  const { addModal } = useModals()
  const { handleSuccess, handleClose } = useVippsRegisterModal()

  useEffect(() => {
    addModal({
      key: 'vipps-register',
      hash: 'vipps-register',
      Component: (
        <SlideInBody>
          <VippsRegisterForm
            consents={consents}
            onSuccess={handleSuccess}
            cmsPlaceholders={cmsPlaceholders}
          />
        </SlideInBody>
      ),
      props: {
        title: t('auth.vipps.vipps-register.modal-title'),
        customClassName: 'vipps-register-modal',
        onClose: handleClose,
      },
    })
  }, [addModal, cmsPlaceholders, consents, handleClose, handleSuccess, t])

  return null
}
